module.exports = __webpack_public_path__ + "img/09.cb4a567a.png";